import { render, staticRenderFns } from "./NonDocForm.vue?vue&type=template&id=02136a77"
import script from "./NonDocForm.vue?vue&type=script&lang=js"
export * from "./NonDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports